// fechas.js — helpers de fecha compartidos por toda la app (dd/mm/aaaa <-> ISO).
// El backend siempre manda/espera ISO (YYYY-MM-DD o YYYY-MM-DDTHH:MM:SS); en
// pantalla se muestra siempre en formato español dd/mm/aaaa — y, si el valor
// trae una hora real (no medianoche exacta 00:00:00, que es lo que hay
// cuando solo se guardó el día sin hora conocida), también "hh:mm" detrás,
// en TODOS los sitios de la app que muestran una fecha (es la misma función
// en todas partes: Gestionar, Rutas, Administración...).
export const isoToEs = (iso) => {
  if (!iso) return "";
  const s = String(iso).slice(0, 10);
  const [y, m, d] = s.split("-");
  if (!(y && m && d)) return s;
  const fecha = `${d}/${m}/${y}`;
  const hora = String(iso).match(/[T ](\d{2}):(\d{2}):(\d{2})/);
  if (!hora) return fecha;
  const [, hh, mm, ss] = hora;
  return (hh === "00" && mm === "00" && ss === "00") ? fecha : `${fecha} ${hh}:${mm}`;
};

export const esToIso = (es) => {
  const m = (es || "").trim().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (!m) return "";
  const [, d, mo, y] = m;
  return `${y}-${mo.padStart(2, "0")}-${d.padStart(2, "0")}`;
};
